import * as React from 'react'

import { Check, HelpCircle, X } from 'lucide-react'

// Define a more specific type for the props for better type safety
interface SummaryStatisticsProps {
	summaryStatistics?: {
		passed?: number
		failed?: number
		partial?: number
	}
}

const SummaryStatistics: React.FC<SummaryStatisticsProps> = ({
	summaryStatistics,
}) => {
	// If no stats are provided, render nothing
	if (!summaryStatistics) {
		return null
	}

	const { passed, failed, partial } = summaryStatistics

	return (
		<div className="flex flex-row items-center gap-2">
			{passed > 0 && (
				<div className="flex items-center gap-1 rounded bg-green-500/10 px-1.5 py-0.5">
					<Check className="h-4 w-4 text-green-600" />
					<span className="text-xs font-bold text-green-700">
						{passed}
					</span>
				</div>
			)}

			{failed > 0 && (
				<div className="flex items-center gap-1 rounded bg-red-500/10 px-1.5 py-0.5">
					<X className="h-4 w-4 text-red-600" />
					<span className="text-xs font-bold text-red-700">
						{failed}
					</span>
				</div>
			)}

			{partial > 0 && (
				<div className="flex items-center gap-1 rounded bg-sky-500/10 px-1.5 py-0.5">
					<HelpCircle className="h-4 w-4 text-sky-600" />
					<span className="text-xs font-bold text-sky-700">
						{partial}
					</span>
				</div>
			)}
		</div>
	)
}

export default SummaryStatistics
